export default "__VITE_ASSET__df286015__"